module.exports = __webpack_public_path__ + "media/content-creator/pets-2-f73bf31b.png";